module.exports = __webpack_public_path__ + "static/media/magicAlt.1518fc46.jpg";